var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-close-btn"},[_c('BaseButton',{attrs:{"aria-label":_vm.ariaLabel,"small":"","dark":"","depressed":""},nativeOn:{"click":function($event){return _vm.$emit('closeAction')}}},[_vm._v(" Close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }